import { api } from '@packages/backend/convex/_generated/api';
import { createFileRoute, Link } from '@tanstack/react-router';
import { useQuery } from 'convex-helpers/react';
import { ArrowLeft } from 'lucide-react';
import { ActionButton } from '@/components/ActionButton';
import { ErrorAlert } from '@/components/ErrorAlert';
import { LoadingIcon } from '@/components/LoadingIcon';
import { EftposIntegrationCard } from '@/features/ipads/EftposIntegrationCard';
import { IPadDetailsCard } from '@/features/ipads/IPadDetailsCard';
import { usePosConfig } from '@/routes/restaurant/useRestaurantData';

export const Route = createFileRoute('/r/$restaurantId/s/ipads/$deviceId')({
  component: IPadDetailsPage,
});

function IPadDetailsPage() {
  const { restaurantId, deviceId } = Route.useParams();
  const { data, error, isError, isPending } = useQuery(api.iPads.getDevice, {
    restaurantId,
    deviceId,
  });
  const posConfig = usePosConfig();

  if (isPending) return <LoadingIcon />;
  if (isError) return <ErrorAlert message={error.message} title="Error loading iPad details" />;
  if (!data) return <div>iPad not found.</div>;

  const { device, heartbeats } = data;
  // The USB printer plugged into this iPad points at it via `attachedToIPadUuid`.
  const printerName =
    posConfig?.posPrinters.find((p) => p.attachedToIPadUuid === device.uuid)?.name ?? null;

  return (
    <div>
      <div className="mb-4">
        <ActionButton asChild variant="outline" size="sm">
          <Link to="/r/$restaurantId/s/ipads" params={{ restaurantId }}>
            <ArrowLeft className="h-4 w-4" />
            Back to list
          </Link>
        </ActionButton>
      </div>

      <IPadDetailsCard
        device={device}
        heartbeats={heartbeats}
        printerName={printerName}
        isPrimary={device.uuid === posConfig?.primaryIPadUuid}
      />

      <EftposIntegrationCard restaurantId={restaurantId} posTerminalUuid={device.uuid} />
    </div>
  );
}
